import { Placeholder } from 'rsuite';
import styled from 'styled-components';

const PropertyInspectionsWrapper = styled.div`
  padding: 0 24px;
  height: 40vh;
`;

const PropertyInspectionHeader = styled.div`
  display: grid;
  grid-template-columns: 5fr 1fr;
  gap: 16px;
`;

const ButtonWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: end;
`;

const StatusWrapper = styled.div`
  margin: 8px 0 16px;
`;

const AddressPlaceholder = styled(Placeholder.Paragraph)`
  .rs-placeholder-paragraph-graph {
    width: 25px;
    height: 25px;
  }

  .rs-placeholder-paragraph-rows .rs-placeholder-paragraph-row:first-child {
    height: 20px;
    margin-top: 5px;
  }
  width: 60%;
`;

const StatusPlaceholder = styled(Placeholder.Paragraph)`
  width: 200px;
`;

const HeaderPlaceholder = styled(Placeholder.Paragraph)`
  .rs-placeholder-paragraph-rows .rs-placeholder-paragraph-row:first-child {
    height: 16px;
  }
`;

const MediumHeaderPlaceholder = styled(HeaderPlaceholder)`
  width: 150px;
`;

const ActionButtonPlaceholder = styled(Placeholder.Graph)`
  width: 150px;
  height: 36px;
`;

const SmallRowPlaceholder = styled(HeaderPlaceholder)`
  height: 12px;
`;

export const InspectionsSkeleton = () => {
  return (
    <PropertyInspectionsWrapper>
      <PropertyInspectionHeader>
        <div>
          <AddressPlaceholder rows={1} graph="square" active />
          <StatusWrapper>
            <StatusPlaceholder rows={1} rowHeight={14} active />
          </StatusWrapper>
          <MediumHeaderPlaceholder rows={1} active />
        </div>
        <ButtonWrapper>
          <ActionButtonPlaceholder active />
        </ButtonWrapper>
      </PropertyInspectionHeader>

      <SmallRowPlaceholder rows={1} active />
      <SmallRowPlaceholder rows={1} active />
      <SmallRowPlaceholder rows={1} active />
      <SmallRowPlaceholder rows={1} active />
    </PropertyInspectionsWrapper>
  );
};
